import {
  ChevronRight,
  HelpCircle,
  Home,
  Mail,
  MessageCircle,
} from "lucide-react";

const WHATSAPP_HREF = "https://wa.me/+50672023442";
const SUPPORT_EMAIL = "oscar@3v0luci0n.com";

interface AyudaProps {
  setView?: React.Dispatch<React.SetStateAction<string>>;
}

const Ayuda = ({ setView }: AyudaProps) => {
  return (
    <div className="w-full max-w-3xl space-y-5 px-4 pb-2 md:max-w-none">
      <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5">
        <div className="flex items-start gap-3 sm:gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#205f43]/10 text-[#205f43] sm:h-14 sm:w-14">
            <HelpCircle className="h-6 w-6 sm:h-7 sm:w-7" strokeWidth={1.75} />
          </span>
          <div className="min-w-0 flex-1">
            <h1 className="text-lg font-semibold tracking-tight text-gray-900 sm:text-xl">
              ¿Necesitás ayuda?
            </h1>
            <p className="mt-1.5 text-sm leading-relaxed text-gray-600 sm:text-base">
              Elegí un canal y escribinos. Te respondemos lo antes posible.
            </p>
          </div>
        </div>
      </div>

      <div>
        <h2 className="mb-2 text-sm font-semibold text-gray-800">
          Canales de contacto
        </h2>
        <div className="grid gap-3 sm:grid-cols-2">
          <a
            href={WHATSAPP_HREF}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-3 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm transition hover:border-[#205f43]/40 hover:shadow-md"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-600">
              <MessageCircle className="h-5 w-5" />
            </span>
            <div className="min-w-0 flex-1 text-left">
              <p className="text-sm font-medium text-gray-900">WhatsApp</p>
              <p className="text-xs text-gray-500">Chateá con el equipo</p>
            </div>
            <ChevronRight className="h-5 w-5 shrink-0 text-gray-400 transition group-hover:translate-x-0.5 group-hover:text-[#205f43]" />
          </a>

          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="group flex items-center gap-3 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm transition hover:border-[#205f43]/40 hover:shadow-md"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-sky-50 text-sky-600">
              <Mail className="h-5 w-5" />
            </span>
            <div className="min-w-0 flex-1 text-left">
              <p className="text-sm font-medium text-gray-900">Correo</p>
              <p className="truncate text-xs text-gray-500" title={SUPPORT_EMAIL}>
                {SUPPORT_EMAIL}
              </p>
            </div>
            <ChevronRight className="h-5 w-5 shrink-0 text-gray-400 transition group-hover:translate-x-0.5 group-hover:text-[#205f43]" />
          </a>
        </div>
      </div>

      {setView ? (
        <div>
          <button
            type="button"
            onClick={() => setView("Home")}
            className="flex w-full items-center justify-center gap-2 rounded-2xl border border-gray-200 bg-white px-4 py-3.5 text-sm font-medium text-gray-800 shadow-sm transition hover:border-[#205f43]/40 sm:w-auto"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#205f43]/10 text-[#205f43]">
              <Home className="h-4 w-4" />
            </span>
            Volver al inicio
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default Ayuda;
